export const formatCategoryName = (rawCategory: any, t?: any): string => {
  try {
    const translate = typeof t === 'function' ? t : (k: string) => k;

    if (!rawCategory) {
      const fallback = translate('news_page.cat_culture');
      return (typeof fallback === 'string' && fallback !== 'news_page.cat_culture') ? fallback : '';
    }

    let catString = '';
    if (typeof rawCategory === 'object' && rawCategory !== null) {
      catString = rawCategory.name || 
                  rawCategory.title || 
                  rawCategory.attributes?.name || 
                  rawCategory.attributes?.title || 
                  rawCategory.data?.attributes?.name || 
                  rawCategory.data?.name || 
                  '';
    } else if (typeof rawCategory === 'string') {
      catString = rawCategory;
    } else if (rawCategory) {
      catString = String(rawCategory);
    }

    if (!catString || typeof catString !== 'string') {
      const fallback = translate('news_page.cat_culture');
      return (typeof fallback === 'string' && fallback !== 'news_page.cat_culture') ? fallback : '';
    }

    const normalized = catString.trim();
    if (!normalized) {
      const fallback = translate('news_page.cat_culture');
      return (typeof fallback === 'string' && fallback !== 'news_page.cat_culture') ? fallback : '';
    }

    if (['press', 'Basin', 'Daxuyaniyên Çapemeniyê', 'Basın Bültenleri', 'Press Releases', 'بيانات صحفية'].includes(normalized)) {
      return translate('news_page.cat_press') || normalized;
    }
    if (['campaigns', 'Kampanya', 'Kampanyayên Me', 'Kampanyalar', 'Campaigns', 'الحملات'].includes(normalized)) {
      return translate('news_page.cat_campaigns') || normalized;
    }
    if (['culture', 'Kultur', 'Çand & Huner', 'Kültür & Sanat', 'Culture & Art', 'Kültür ve Sanat', 'Kültür-Sanat', 'الثقافة والفنون'].includes(normalized)) {
      return translate('news_page.cat_culture') || normalized;
    }
    if (['gallery', 'Galeri', 'Galerî', 'Gallery', 'معرض'].includes(normalized)) {
      return translate('news_page.cat_gallery') || normalized;
    }
    if (['events', 'Etkinlikler', 'Çalakî', 'Events', 'فعاليات'].includes(normalized)) {
      return translate('news_page.cat_events') || normalized;
    }
    if (['brochures', 'Brosur', 'Broşur û Materyal', 'Broşür ve Materyaller', 'Broşür', 'Brochures & Materials', 'كتيبات ومواد'].includes(normalized)) {
      return translate('news_page.cat_brochures') || normalized;
    }
    if (['kalem', 'KadininKalemi', 'Pênûsa Jinê', 'Kadının Kalemi', "Woman's Pen", 'قلم المرأة'].includes(normalized)) {
      return translate('nav.kalem') || normalized;
    }
    if (['Rapor', 'Report', 'reports', 'تقرير'].includes(normalized)) {
      return translate('resources.report') || normalized;
    }

    const i18nKey = `news_page.cat_${normalized.toLowerCase()}`;
    const translated = translate(i18nKey);
    if (translated && translated !== i18nKey) {
      return translated;
    }

    return normalized;
  } catch (err) {
    console.error('Error formatting category name:', err);
    return '';
  }
};
